import { jsx, Fragment } from 'react/jsx-runtime';
import { C as ClientComponent } from './ClientComponent-shared-BPxYHlQE.mjs';
import { Suspense } from 'react';
import { g as getBlokComponent, a as getAdditionalDataHook } from './defineBloks-shared-oexg9VmF.mjs';

const ServerComponent = ({ blok, ...rest })=>{
    const Component = getBlokComponent(blok.component);
    if (!Component) {
        const errorMessage = `Component: "${blok.component}" not found`;
        return /*#__PURE__*/ jsx("div", {
            children: errorMessage
        });
    }
    if (Component && typeof Component === "object") {
        return /*#__PURE__*/ jsx(Suspense, {
            fallback: Component.fallback ? /*#__PURE__*/ jsx(Component.fallback, {
                ...rest,
                blok: blok
            }) : null,
            children: /*#__PURE__*/ jsx(AdditionalDataLoader, {
                ...rest,
                blok: blok
            })
        });
    }
    return /*#__PURE__*/ jsx(Suspense, {
        children: /*#__PURE__*/ jsx(AdditionalDataLoader, {
            ...rest,
            blok: blok
        })
    });
};
const AdditionalDataLoader = async ({ blok, ...rest })=>{
    const Component = getBlokComponent(blok.component);
    const additionalDataHook = getAdditionalDataHook();
    const additionalDataPromise = additionalDataHook({
        preview: rest.preview,
        blok
    });
    if (!Component) {
        const errorMessage = `Component: "${blok.component}" not found`;
        return /*#__PURE__*/ jsx("div", {
            children: errorMessage
        });
    }
    if (Component && typeof Component === "object") {
        if ("fetcher" in Component) {
            return /*#__PURE__*/ jsx(ServerComponentWithFetcher, {
                ...rest,
                blok: blok,
                componentData: Component,
                additionalDataPromise: additionalDataPromise
            });
        }
        const additionalData = await additionalDataPromise;
        return /*#__PURE__*/ jsx(ServerComponentOnly, {
            ...rest,
            ...additionalData,
            blok: blok,
            componentData: Component
        });
    }
    const additionalData = await additionalDataPromise;
    return /*#__PURE__*/ jsx(Component, {
        ...additionalData,
        ...rest,
        blok: blok
    });
};
const ServerComponentOnly = ({ blok, componentData, ...rest })=>{
    if (!componentData) {
        const errorMessage = `Component: "${blok.component}" not found`;
        return /*#__PURE__*/ jsx("div", {
            children: errorMessage
        });
    }
    const Blok = componentData.blok;
    return /*#__PURE__*/ jsx(Blok, {
        ...rest,
        blok: blok
    });
};
const ServerComponentWithFetcher = async ({ blok, componentData, additionalDataPromise, ...rest })=>{
    if (!componentData) {
        const errorMessage = `Component: "${blok.component}" not found`;
        return /*#__PURE__*/ jsx("div", {
            children: errorMessage
        });
    }
    const dataPromise = componentData.fetcher({
        blok,
        preview: rest.preview
    });
    const [data, additionalData] = await Promise.all([
        dataPromise,
        additionalDataPromise
    ]);
    const Blok = componentData.blok;
    return /*#__PURE__*/ jsx(Blok, {
        ...rest,
        ...additionalData,
        blok: blok,
        data: data
    });
};

const StoryblokComponent = ({ blok, preview, ...rest })=>{
    if (typeof preview === "undefined") {
        throw new Error("Preview was not passed down as a prop to StoryblokComponent, this will cause a fetch overflow", {
            cause: blok.component
        });
    }
    if (!blok) {
        const errorMessage = "Please provide a blok";
        console.error(errorMessage);
        return /*#__PURE__*/ jsx("div", {
            children: errorMessage
        });
    }
    if (!blok.component) {
        const errorMessage = `Component is not listed in bloks`;
        console.error(errorMessage);
        return /*#__PURE__*/ jsx("div", {
            children: errorMessage
        });
    }
    if (preview) {
        return /*#__PURE__*/ jsx(ClientComponent, {
            ...rest,
            blok: blok,
            preview: true
        });
    }
    return /*#__PURE__*/ jsx(ServerComponent, {
        ...rest,
        preview: false,
        blok: blok
    });
};
const StoryblokComponentList = ({ bloks, preview, ...rest })=>{
    return /*#__PURE__*/ jsx(Fragment, {
        children: bloks.map((blok)=>/*#__PURE__*/ jsx(StoryblokComponent, {
                blok: blok,
                preview: preview,
                ...rest
            }, blok._uid))
    });
};

export { StoryblokComponent as S, StoryblokComponentList as a };
